export default "__VITE_ASSET__b5746818__"